module.exports = __webpack_public_path__ + "img/17.e7c1d250.svg";